// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"3157f69e","925":"f4e99d57","1093":"ebe2b45a","2245":"f4e99d57","3471":"3157f69e","4768":"42c18e82","5469":"8f9387ad","7569":"ebe2b45a"}[chunkId] + ".chunk.css";
};